
import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { RemixIcon } from "@/components/shared/RemixIcon";

interface SearchBarProps {
  placeholder?: string;
  onSearch: (query: string) => void;
  className?: string;
}

export const SearchBar = ({
  placeholder = "Search...",
  onSearch,
  className
}: SearchBarProps) => {
  const [query, setQuery] = useState("");
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setQuery(value);
    onSearch(value);
  };
  
  return (
    <div className={`relative ${className}`}>
      <RemixIcon 
        name="search-line" 
        className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" 
        size="md"
      />
      <Input 
        type="search" 
        placeholder={placeholder} 
        value={query} 
        onChange={handleChange} 
        className="pl-10 w-full bg-slate-50" 
      />
    </div>
  );
};
